export const REASON_CODES = {
	INACTIVE_ACCOUNT: 'inactive_account',
	INVALID_OR_EXPIRED_ACCESS_TOKEN: 'invalid_or_expired_access_token',
} as const;
